import React, { memo } from "react";
import { vehicleThumbnailAfter } from "./api/Url";
import { getReviewStatusIcon } from "./components/AbandonedVehicleStatusIconNew";
import { Match } from "./loaders/abandonedVehicleLoader";
import { showAbandonedVehicleReviewStatus } from "./api/EnumUtils";
import { RowComponentProps } from "react-window";
import { AbandonedVehicleReviewStatus } from "./api/Network";

interface AbandonedVehicleSideBarProps {
    vehicle:     Match;
    onClick:     ( match: Match ) => void;
    selectedId?: number;
}

export function AbandonedVehicleSideBarItem( { vehicle, onClick, selectedId }: AbandonedVehicleSideBarProps ) {
    const isSelected = selectedId === vehicle.abandonedVehicleId;
    const bg = isSelected ? "bg-primary text-white" : "bg-body text-body";
    const iconRec = getReviewStatusIcon( vehicle.reviewStatus?.status ?? null );
    const { icon, size, color, borderColor } = iconRec;
    const className = `d-flex align-items-center match-item rounded-3 border border-2 shadow-sm p-4 ${bg} hover-highlight ${borderColor}`;
    const reviewStatus = vehicle.reviewStatus !== null //this ought to always be null on this page...
        ? showAbandonedVehicleReviewStatus( vehicle.reviewStatus.status ) : "Invalid Review Status!";

    function getCallToAction( reviewStatus: AbandonedVehicleReviewStatus | undefined ) {
        if( reviewStatus === AbandonedVehicleReviewStatus.New ) {
            return "Needs Attention";
        }
        if( reviewStatus === AbandonedVehicleReviewStatus.NotActionable ) {
            return "Vehicle Allowed";
        }
        if( reviewStatus === AbandonedVehicleReviewStatus.Actionable ) {
            return "Awaiting Enforcement"
        }
        return "Error";
    }

    return <div
        style={{ cursor: "pointer" }}
        className={className}
        onClick={ () => onClick( vehicle ) }>
        <div className="position-relative d-flex flex-column align-items-center me-3 flex-shrink-0 border-2">
            <div className="position-absolute" style={{ top: -12, left: -10 }}>
                {React.cloneElement( icon, { className: `${color} ${size}` } )}
            </div>
            <img
                loading="lazy"
                src={vehicleThumbnailAfter( vehicle.abandonedVehicleId )}
                alt={`${vehicle.abandonedVehicleId} thumbnail`}
                className="match-item-thumbnail border rounded bg-black" />
        </div>
        <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-center gap-1 small fw-bold">
                #{vehicle.abandonedVehicleId} 
            </div>
            <div className="small">
                <div className="d-flex gap-1">
                    <div>
                        {getCallToAction( vehicle.reviewStatus?.status )}
                        {/* {vehicle.attributes.address?.split(",")[0]} */}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}

export const Row = ( { index, style, vehicles, selectedId, onClick }: RowComponentProps<{
    selectedId?: number;
    vehicles:    Match[];
    onClick:     ( m: Match ) => void;
}> ) => {
    const vehicle = vehicles[index];
    return <div style={{ ...style, overflow: "hidden" }}>
        <AbandonedVehicleSideBarItemMemo
            selectedId={selectedId}
            vehicle={vehicle}
            onClick={onClick} />
    </div>;
}

export const AbandonedVehicleSideBarItemMemo = memo( AbandonedVehicleSideBarItem );
